<template>
  <el-dialog
    class="widget-details-popup"
    :visible.sync="opened"
    append-to-body
    destroy-on-close
    width="912px"
    :show-close="showClose"
    :close-on-click-modal="closeOnClickModal"
  >
    <slot name="content"></slot>
  </el-dialog>
</template>

<script>
export default {
  name: "popup912x616",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      opened: false
    };
  },
  watch: {
    visible(v) {
      this.opened = v;
    },
    opened(v) {
      if (v) {
        return;
      }
      this.$emit("update:visible", null);
    }
  }
};
</script>

<style lang="stylus">
.widget-details-popup
    & > .el-dialog
        margin-top calc(50vh - 308px) !important
        // margin-top calc(50vh - 158px) !important
        height 616px
        // height 316px
        & > .el-dialog__header
            padding 0

            & .el-dialog__headerbtn
                /*top 7px*/
                /*right 7px*/
                z-index 10

        & > .el-dialog__body
            padding 0
            & > section
                position absolute
                top 0
                bottom 0
                width 912px
</style>
